<template>
  <v-container fluid class="dashboard-container">
    <v-row class="dashboard-title-row">
      <v-col cols="12">
        <h1 class="dashboard-title">Dashboard Templus</h1>
      </v-col>
    </v-row>

    <!-- Cards Principais -->
    <v-row v-if="user.tipo == 'LIDER'">
      <v-col cols="12" md="4">
        <v-card class="dashboard-card card-altura-fixa tp-card tp-card-hover" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left>group</v-icon>
            Membros
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdMembro}}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="dashboard-card card-altura-fixa tp-card tp-card-hover" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left>person_add</v-icon>
            Novo Membro
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="CPF do Membro"
              outlined
              dense
              v-mask="'###.###.###-##'"
              hide-details
              required
              v-validate="'required|cpf'"
              :error-messages="errors.collect('cpf')"
              data-vv-name="cpf"
              type="tel"
              v-model="cpfMembro"
              @change="consultaMembro(cpfMembro)"
              color="#00695C"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="dashboard-card card-altura-fixa tp-card tp-card-hover" elevation="0" @click="dialogSolicitacoes=true">
          <v-card-title class="card-title">
            <v-icon large left>send</v-icon>
            Solicitações
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdSolicitacoesEnviadas}}</div>
            <div class="subtitle-1">Solicitações Enviadas</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dashboard Admin/Gerente -->
    <v-row v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE' || user.tipo == 'BACKUP'">
      <!-- Cards de Estatísticas -->
      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#00253E'" dark>
          <v-card-title class="card-title">
            <v-icon large left>people</v-icon>
            Total Cadastros
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdTotal}}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#00695C'" dark>
          <v-card-title class="card-title">
            <v-icon large left>group</v-icon>
            Membros
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdMembro}}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#0E8C76'" dark>
          <v-card-title class="card-title">
            <v-icon large left>church</v-icon>
            Congregados
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdCongregado}}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Crianças agora -->
      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#13877A'" dark>
          <v-card-title class="card-title">
            <v-icon large left>child_care</v-icon>
            Crianças
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdMeninos + qtdMeninas}}</div>
            <div class="subtitle-1">Total de Crianças</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Células agora -->
      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#1AA28C'" dark>
          <v-card-title class="card-title">
            <v-icon large left>account_balance</v-icon>
            Redes
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdRedes}}</div>
            <div class="subtitle-1">Total de Redes</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="2">
        <v-card class="dashboard-card card-altura-fixa stat-card-colored" elevation="2" :color="'#2BB89E'" dark>
          <v-card-title class="card-title">
            <v-icon large left>groups</v-icon>
            Células
          </v-card-title>
          <v-card-text class="text-center">
            <div class="display-3 font-weight-bold">{{qtdCelulas}}</div>
            <div class="subtitle-1">Total de Células</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Gráficos -->
      <v-col cols="12" md="6">
        <v-card class="dashboard-card tp-card" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left color="primary">pie_chart</v-icon>
            Membros por Célula
          </v-card-title>
          <v-card-text>
            <apexchart
              v-if="graficoMembrosCelula.series.length && graficoMembrosCelula.options.labels.length"
              type="donut"
              height="350"
              :options="graficoMembrosCelula.options"
              :series="graficoMembrosCelula.series"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="dashboard-card tp-card" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left color="primary">bubble_chart</v-icon>
            Membros por Rede
          </v-card-title>
          <v-card-text>
            <apexchart
              v-if="graficoMembrosRede.series.length && graficoMembrosRede.options.labels.length"
              type="donut"
              height="350"
              :options="graficoMembrosRede.options"
              :series="graficoMembrosRede.series"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Estatísticas de Gênero -->
      <v-col cols="12" md="6">
        <v-card class="dashboard-card tp-card" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left color="primary">wc</v-icon>
            Distribuição por Gênero
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="text-center">
                  <v-icon large color="blue">male</v-icon>
                  <div class="display-2 font-weight-bold">{{qtdHomens}}</div>
                  <div class="subtitle-1">Homens</div>
                  <v-progress-linear
                    :value="percenteHomens"
                    color="blue"
                    height="10"
                    class="mt-2"
                  ></v-progress-linear>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-center">
                  <v-icon large color="pink">female</v-icon>
                  <div class="display-2 font-weight-bold">{{qtdMulheres}}</div>
                  <div class="subtitle-1">Mulheres</div>
                  <v-progress-linear
                    :value="percenteMulheres"
                    color="pink"
                    height="10"
                    class="mt-2"
                  ></v-progress-linear>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Estatísticas de Crianças -->
      <v-col cols="12" md="6">
        <v-card class="dashboard-card tp-card" elevation="0">
          <v-card-title class="card-title">
            <v-icon large left color="primary">child_care</v-icon>
            Distribuição de Crianças
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <div class="text-center">
                  <v-icon large color="blue">boy</v-icon>
                  <div class="display-2 font-weight-bold">{{qtdMeninos}}</div>
                  <div class="subtitle-1">Meninos</div>
                  <v-progress-linear
                    :value="percenteMeninos"
                    color="blue"
                    height="10"
                    class="mt-2"
                  ></v-progress-linear>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-center">
                  <v-icon large color="pink">girl</v-icon>
                  <div class="display-2 font-weight-bold">{{qtdMeninas}}</div>
                  <div class="subtitle-1">Meninas</div>
                  <v-progress-linear
                    :value="percenteMeninas"
                    color="pink"
                    height="10"
                    class="mt-2"
                  ></v-progress-linear>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Mantendo os diálogos existentes -->
    <v-row>
      <v-dialog v-model="dialog" max-width="350px">
        <v-card style="border-radius: 10px;">
          <v-card-title style="justify-content: center; padding: 8px;">
            <span class="texto" style="margin-bottom: -23px">{{acao}}</span>
          </v-card-title>
          <v-card-text v-if="!validacao" style="text-align: center;padding: 0px 5px 0px">
            <v-container>
              <v-row align="center" justify="center" v-if="acao=='CHECKOUT'">
                <v-col cols="12" sm="6" md="12">
                  <p class="texto" :style="`color:${corValidacao}`">{{evento}}</p>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" v-if="acao=='CHECKIN'">
                <v-col cols="12" sm="6" md="12">
                  <v-radio-group v-model="tipo" row hide-details>
                    <v-radio color="#00695C" label="QRCODE" value="1"></v-radio>
                    <v-radio color="#00695C" label="CÓDIGO" value="2"></v-radio>
                    <v-radio color="#00695C" label="CPF" value="3"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="12" v-if="tipo=='1'">
                  <qrcode-stream @decode="onDecode"></qrcode-stream>
                </v-col>
                <v-col cols="12" sm="6" md="12" v-if="tipo=='2'">
                  <v-text-field light label="CÓDIGO" color="#00695C" type="tel" outlined hide-details dense v-model="codigo"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="12" v-if="tipo=='3'">
                  <v-text-field light label="CPF" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-text v-if="validacao" style="text-align: center;padding: 0px 5px 0px;">
            <v-container>
              <br>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <v-icon large :color="corValidacao" style="font-size: 100px">{{iconValidacao}}</v-icon>
                </v-col>
                <v-col cols="12" sm="6" md="6" style="padding: 2px;" v-if="participantes > 1">
                  <p class="texto" :style="`color:${corValidacaoParticipantes}; font-size: 20px; background-color: ${corValidacao}; padding: 10px`"><b>{{participantes}} participantes</b></p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                  <p class="texto" :style="`color:${corValidacao}; font-size: 17px`"><b>{{msgValidacao}}</b></p>
                </v-col>
                <v-col cols="12" sm="6" md="12" style="padding: 2px;" v-if="detalhes">
                  <p class="texto" :style="`color:${corValidacao}; font-size: 17px`">
                    <b>{{detalhes}}</b>
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions v-if="!validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
            <v-container fluid grid-list-md>
              <v-layout row wrap justify-center>
                <v-flex xs6 sm6 lg6 v-if="tipo!=1">
                  <v-btn :loading="loading" dark depressed block color="#00695C" style="border-radius: 7px;" large @click="validarInscricao">Validar</v-btn>
                </v-flex>
                <v-flex xs6 sm6 lg6>
                  <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
          <v-card-actions v-if="validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
            <v-container fluid grid-list-md>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 lg12>
                  <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="closeResultado">Fechar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoInscricoesLocalizadas" max-width="900px">
        <v-card>
          <v-card-title>Inscrições</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <v-data-table :headers="tabela.cabecalho" :items="tabela.conteudo" :items-per-page="tabela.itensPorPagina" hide-default-footer>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn text outlined color="success" @click="doCheckin(item)">
                  <v-icon left>check_circle</v-icon>Check-in
                </v-btn>
              </template>
              <template v-slot:[`item.checkin`]="{ item }">
                <p v-if="item.checkin" style="font-size: 10px; margin: 0px">Check-in efetuado em {{ transformaData(item.checkin, 'DD/MM/YYYY') }} às {{ transformaData(item.checkin, 'HH:mm:ss') }} por {{ item.userValidatorCheckinId }}.</p>
                <p>NÃO EFETUADO</p>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogoInscricoesLocalizadas = false" color="error">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitacaoMembro" max-width="900px">
        <v-card>
          <v-card-title>Solicitar novo membro</v-card-title>
          <v-card-text style="padding-bottom: 0px">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Nome" color="#00695C" readonly outlined hide-details dense v-model="this.membro.nome"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Sexo" color="#00695C" readonly outlined hide-details dense v-model="this.membro.sexo"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Telefone" color="#00695C" readonly outlined hide-details dense v-model="this.membro.telefone"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Celula" color="#00695C" readonly outlined hide-details dense v-model="this.membro.celula.nome"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Lider Atual" color="#00695C" readonly outlined hide-details dense v-model="this.membro.celula.lider"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field light label="Rede" color="#00695C" readonly outlined hide-details dense v-model="this.membro.celula.rede.nome"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed dark @click="solicitarMembro()" color="#00253E">Solicitar Membro</v-btn>
            <v-btn depressed @click="dialogoSolicitacaoMembro = false" color="error">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog persistent v-model="dialogAprovacoes" max-width="900px">
        <v-card>
          <template>
            <v-container fluid grid-list-md >
              <v-data-iterator
                :items="membrosPendentes"
                hide-default-footer
              >
                <template v-slot:header>
                  <v-toolbar
                    dark
                    color="#00253E"
                    class="mb-1"
                  > 
                  <v-toolbar-title>Aprovar envio de membros</v-toolbar-title>        
                  </v-toolbar>
                </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.nome"
                      cols="12"
                      sm="6"
                      md="6"
                      lg="6"
                    >
                      <v-card>
                        <v-card-title class="subheading font-weight-bold">
                          {{ item.nome }}
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              Telefone: {{ item.telefone == undefined ? 'sem telefone' : item.telefone}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Celula Atual: {{ item.solicitacaoTransferencia.celulaAtual}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Lider Atual: {{ item.solicitacaoTransferencia.liderAtual}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Líder Solicitante: {{ item.solicitacaoTransferencia.lider }}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Data Solicitação: {{ item.solicitacaoTransferencia.dataSolicitacao }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-card-actions class="justify-end">
                          <v-btn depressed @click="aprovaEnvioMembro(item)" dark color="#00253E">Aprovar Envio</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </template>
          <v-card-actions class="justify-end">
            <v-btn depressed @click="dialogAprovacoes = false" color="error">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog persistent v-model="dialogSolicitacoes" max-width="900px">
        <v-card>
          <template>
            <v-container fluid grid-list-md >
              <v-data-iterator
                :items="membrosSolicitados"
                hide-default-footer
              >
                <template v-slot:header>
                  <v-toolbar
                    dark
                    color="#00253E"
                    class="mb-1"
                  > 
                  <v-toolbar-title>Solicitações Enviadas</v-toolbar-title>        
                  </v-toolbar>
                </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.nome"
                      cols="12"
                      sm="6"
                      md="6"
                      lg="6"
                    >
                      <v-card>
                        <v-card-title class="subheading font-weight-bold">
                          {{ item.nome }}
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              Telefone: {{ item.telefone == undefined ? 'sem telefone' : item.telefone}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Celula Atual: {{ item.solicitacaoTransferencia.celulaAtual}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Lider Atual: {{ item.solicitacaoTransferencia.liderAtual}}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Líder Solicitante: {{ item.solicitacaoTransferencia.lider }}
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Data Solicitação: {{ item.solicitacaoTransferencia.dataSolicitacao }}
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-card-actions class="justify-end">
                          <v-btn depressed @click="cancelaSolicitacao(item)" dark color="#00253E">Cancelar Solicitação</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </template>
          <v-card-actions class="justify-end">
            <v-btn depressed @click="dialogSolicitacoes = false" color="error">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </v-container>
</template>

<script>
// Import component
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import axios from 'axios'
import {
  mapState
} from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      cpfMembro: '',
      diasSelc: 7,
      corSelec: '#388E3C',
      fab: false,
      fullPage: true,
      isLoading: false,
      eventoId: '',
      eventos: [],
      capacidade: 0,
      inscritos: 0,
      inscritosPagos: 0,
      checkinsRealizados: 0,
      checkinsRealizadosTotal: 0,
      reservados: 0,
      confirmados: 0,
      percentCapac: 0,
      percenteMembros: 0,
      percenteCongregados: 0,
      percenteHomens: 0,
      percenteMulheres: 0,
      percentConfirm: 0,
      percentCheckinTotal: 0,
      percentCheckinUser: 0,
      percentualApoio: 0,
      percentualBasico: 0,
      percentualGrandesEventos: 0,
      percentualAtivo: 0,
      percentualEmAnalise: 0,
      percenteReserv: 0,
      percentInscri: 0,
      dialog: false,
      codigo: '',
      cpf: '',
      tipo: '1',
      acao: '',
      evento: '',
      validacao: false,
      loading: false,
      msgValidacao: '',
      iconValidacao: '',
      corValidacao: '',
      contador: '',
      checkin: {
        cod_incricao: '',
        tipo: '',
        eventoId: '',
        userValidatorId: '',
      },
      defaultCheckin: {
        cod_incricao: '',
        tipo: '',
        eventoId: '',
        userValidatorId: '',
      },
      audio: '',
      usaQrcode: false,
      qtdMembro: 0,
      qtdCongregado: 0,
      qtdHomens: 0,
      qtdMulheres: 0,
      qtdTotal: 0,
      qtdApoio: 0,
      qtdBasico: 0,
      qtdGrandesEventos: 0,
      qtdEmAnalise: 0,
      qtdAtivos: 0,
      qtdSolicitacoesEnviadas: 0,
      qtdAprovacoesPendentes: 0,
      participantes: 0,
      detalhes: '',
      corValidacaoParticipantes: '#FFFFFF',
      inscricoesLocalizadas: [],
      dialogoInscricoesLocalizadas: false,
      dialogoSolicitacaoMembro: false,
      dialogAprovacoes: false,
      dialogSolicitacoes: false,
      tabela: {
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Evento', value: 'nomeEvento' },
          { text: 'Check-in', value: 'checkin' },
          { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: [],
        itensPorPagina: -1,
      },
      graficoMembrosCelula: {
        series: [],
        options: {
          colors: [],
          labels: [],
          responsive: [{
            breakpoint: 980,
            options: {
              chart: {
                width: '100%'
              },
              legend: {
                position: 'bottom',
              }
            }
          }]
        },
      },
      graficoMembrosRede: {
        series: [],
        options: {
          colors: [],
          labels: [],
          responsive: [{
            breakpoint: 980,
            options: {
              chart: {
                width: '100%'
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      },
      qtdCelulas: 0,
      qtdRedes: 0,
      qtdMeninos: 0,
      qtdMeninas: 0,
      percenteMeninos: 0,
      percenteMeninas: 0,
      membrosPendentes: [],
      membrosSolicitados: [],
      keys:[
        'Celula',
        'Atual Líder',
        'Telefone',
        'Email',
        'Data da Solicitação'
      ],
      membro: {
        nome: '',
        email: '',
        sexo: '',
        telefone: '',
        celula: {
          nome: '',
          lider: '',
          rede: {
            nome: ''
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      usuarioadmin: state => state.Userpermission,
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
    filteredKeys () {
        return this.keys.filter(key => key !== 'Nome')
      },

  },
  mounted() {
    if (this.user.tipo == 'ADMIN' || this.user.tipo == 'GERENTE' || this.user.tipo == 'LIDER' ||  this.user.tipo == 'BACKUP') {
      this.cadastroTotal()
    } else {
      this.carregaDados()
    }
    this.audio = new Audio(require("../assets/beep.mp3"))
    this.$validator.localize('pt', this.dictionary)
  },
  watch: {
    tipo(val) {
      if (val === '1') {
        this.cpf = ""
        this.$validator.reset()
      } else
      if (val === '2')
        this.codigo = ''
    },

    validacao() {
      this.cpf = ""
      this.codigo = ''
      this.checkin = Object.assign({}, this.defaultCheckin)
    },
  },

  methods: {

    async onDecode(decodedString) {
      this.codigo = decodedString
      this.usaQrcode = true
      await axios.post(baseApiUrl + 'inscricoes/preCheckin?access_token=' + sessionStorage.getItem('accToken'), {"cod_incricao": this.codigo})
      .then(response => {
        if (response.data) {
          if (response.data.length == 1) {
            this.confirmaCheckin()
          } else if (response.data.length > 1) {
            this.tabela.conteudo = response.data
            this.dialog = false
            this.dialogoInscricoesLocalizadas = true
            this.isLoading = false
          }
        }
      })
    },

    async carregaDados() {
      this.isLoading = true
      let url
      if (this.user.tipo == 'KIDS' || this.user.tipo == 'EVENTO') {
        url = 'Eventos?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"},{"tipo":"EM"}]}}'
      } else {
        url = 'Eventos?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"}]}}'
      }
      await axios.get(baseApiUrl + url + '&access_token=' + sessionStorage.getItem('accToken'))
      .then(res => {
        if (res.data) {
          for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.eventos.push(res.data[key])
              }
            }
          }
          
          this.eventos = this.eventos.sort(this.compare)
          if (this.eventos.length > 0) {
            this.eventoId = this.eventos[0].id
            this.quantidadesEvento()
          } else {
            this.isLoading = false
          }
        } else {
          this.isLoading = false
        }
      })
    },

    async quantidadesEvento() {
      for (var key in this.eventos) {
        if (this.eventos.hasOwnProperty(key)) {
          if (this.eventos[key].id == this.eventoId) {
            this.capacidade = this.eventos[key].vagas
            this.reservados = this.eventos[key].reserva
            this.evento = this.eventos[key].nome
          }

        }
      }

      await axios.get(baseApiUrl + 'inscricoes/count?where={"eventoId":"' + this.eventoId + '"}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data.count) {
          this.inscritos = response.data.count
        }
      })
      await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"' + this.eventoId + '"},{"statusPagamento":"PAGO"}]}&access_token=' + sessionStorage.getItem('accToken'))
      .then(response => {
        if (response.data.count) {
          this.inscritosPagos = response.data.count
        }
      })
      this.isLoading = false
    },

    async consultaMembro(cpfMembro){
      if(cpfMembro != ''){
      this.isLoading = true
      await axios.get(baseApiUrl + `Membros?filter={"where":{"cpf":"${cpfMembro}"}, "order":"nome ASC", "include":[{"relation":"celula","scope":{"include":["rede"]}}]}&access_token=` + sessionStorage.getItem('accToken')).then(response => {
          if (response.data != '') {
            this.membro = response.data[0]
            this.isLoading = false
            this.dialogoSolicitacaoMembro = true
          } else {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1", "Membro não localizado!", "INFORMAÇÃO")
          }
        })
      }
    },

    async aprovaEnvioMembro(membro){
        this.isLoading = true
        membro.celulaId = membro.solicitacaoTransferencia.celulaId
        delete membro.celula
        delete membro.solicitacaoTransferencia
        await axios.patch(`${baseApiUrl}Membros/${membro.id}?access_token=${sessionStorage.getItem('accToken')}`, membro)
        .then(res => {
            if (res.data != null) {
              var vm = this;
              this.cadastroTotal()
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
    },

    async cancelaSolicitacao(membro){
      this.isLoading = true
        delete membro.celula
        delete membro.solicitacaoTransferencia
        await axios.post(`${baseApiUrl}Membros/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, membro)
        .then(res => {
            if (res.data != null) {
              var vm = this;
              this.cadastroTotal()
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
    },

    async solicitarMembro(){
      if(this.membro.celula.nome == 'NENHUMA'){
        this.isLoading = true
        this.membro.celulaId = this.user.celulaId
        await axios.patch(`${baseApiUrl}Membros/${this.membro.id}?access_token=${sessionStorage.getItem('accToken')}`, this.membro)
        .then(res => {
            if (res.data != null) {
              var vm = this;
              this.dialogoSolicitacaoMembro = false
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.cadastroTotal()
            }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      }
      else
      if(this.membro.celulaId == this.user.celulaId){
        this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não é possível realizar essa operação, o membro já faz parte dessa célula", "INFORMAÇÃO")
      }
      else{
        this.isLoading = true
        this.membro.solicitacaoTransferencia = {
          "celulaId": this.user.celulaId,
          "celulaAtual": this.membro.celula.nome,
          "rede": this.membro.celula.rede.nome,
          "lider": this.user.nome,
          "liderId": this.user.id,
          "liderAtual": this.membro.celula.lider,
          "igrejaId": this.user.igrejaId,
          "dataSolicitacao": moment().format('DD/MM/YYYY')
        }
        await axios.patch(`${baseApiUrl}Membros/${this.membro.id}?access_token=${sessionStorage.getItem('accToken')}`, this.membro)
        .then(res => {
            if (res.data != null) {
              var vm = this;
              this.dialogoSolicitacaoMembro = false
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.cadastroTotal()
            }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        })
      }
    },

    async solicitacoesEnviadas(){
      const url = `${baseApiUrl}Membros?filter=${encodeURIComponent(JSON.stringify({"where":{"solicitacaoTransferencia.liderId":this.user.id}}))}`;

      try {
        const response = await axios.get(url + '&access_token=' + sessionStorage.getItem('accToken'));
        this.qtdSolicitacoesEnviadas = response.data.length
        this.membrosSolicitados = response.data
      } catch (error) {
        // console.error(error);
      }
    },

    async aprovacoesPendentes(){
      const url = `${baseApiUrl}Membros?filter=${encodeURIComponent(JSON.stringify({"where":{"and":[{"solicitacaoTransferencia": {"neq": null}},{"solicitacaoTransferencia.liderId": {"neq": this.user.id}},{"celulaId": this.user.celulaId}]}, "order":"nome ASC", "include":["celula"]}))}`;
      try {
        const response = await axios.get(url + '&access_token=' + sessionStorage.getItem('accToken'));
        this.qtdAprovacoesPendentes = response.data.length
        this.membrosPendentes = response.data
      } catch (error) {
        // console.error(error);
      }
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    comparacaoCelula(a, b) {
      // Use toUpperCase() to ignore character casing
      const celulaA = a.celula;
      const celulaB = b.celula;

      let comparison = 0;
      if (celulaA > celulaB) {
        comparison = 1;
      } else if (celulaA < celulaB) {
        comparison = -1;
      }
      return comparison;
    },

    comparacaoRede(a, b) {
      // Use toUpperCase() to ignore character casing
      const redeA = a.rede;
      const redeB = b.rede;

      let comparison = 0;
      if (redeA > redeB) {
        comparison = 1;
      } else if (redeA < redeB) {
        comparison = -1;
      }
      return comparison;
    },

    openDialog(acao) {
      if (acao == 'CHECKIN') {
        this.tipo = "1"
        this.audio.play()
      } else
      if (acao == 'CHECKOUT')
        this.tipo = "0"
      this.codigo = ''
      this.cpf = ''

      this.acao = acao
      this.dialog = true
    },

    async validarInscricao() {
      this.checkin = Object.assign({}, this.defaultCheckin)
      this.loading = true
      if (this.acao == 'CHECKIN') {
        this.confirmaCheckin()
      } else
      if (this.acao == 'CHECKOUT') {
        this.confirmaCheckout()
      } else {
        this.loading = false
      }
    },

    async confirmaCheckin() {
      var vm = this;
      if (this.codigo != '') {
        this.checkin.cod_incricao = this.codigo
        this.checkin.tipo = this.acao
        this.checkin.eventoId = this.eventoId
        this.checkin.userValidatorId = this.user.id
        await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
          .then(res => {
            if (res.data != '') {
              switch (res.data.codigo) {
                case 1:
                  //'Validação já efetuada anteriormente' 
                  if (this.usaQrcode)
                    this.audio.play()
                  this.participantes = res.data.participantes
                  this.detalhes = res.data.detalhes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 2:
                  //'Vagas esgotadas para o evento'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 3:
                  //'Validação efetuada com sucesso'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.participantes = res.data.participantes
                  this.detalhes = res.data.detalhes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'check_circle_outline'
                  this.corValidacao = '#43A047'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 5:
                  //'Inscrição não localizada pra este evento'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 8:
                  //'Inscrição com pagamento pendente'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                default:
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
              }
            }
          }).catch(() => {
            this.isLoading = false
            this.close()
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
          })
      } else
      if (this.cpf != '') {
        await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"cpf":"${this.cpf}"},{"eventoId":"${this.eventoId}"}]}}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            if (res.data != '') {
              this.checkin.cod_incricao = res.data[0].cod_incricao
            } else {
              this.checkin.cod_incricao = 9999
            }
          })

        this.checkin.tipo = this.acao
        this.checkin.eventoId = this.eventoId
        this.checkin.userValidatorId = this.user.id
        await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
          .then(res => {
            if (res.data != '') {
              switch (res.data.codigo) {
                case 1:
                  //'Validação já efetuada anteriormente'                  
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  break;
                case 3:
                  //'Validação efetuada com sucesso'                  
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'check_circle_outline'
                  this.corValidacao = '#43A047'
                  this.validacao = true
                  this.loading = false
                  break;
                case 5:
                  //'Inscrição não localizada pra este evento'                  
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  break;
                case 8:
                  //'Inscrição com pagamento pendente'
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                default:
                  break;
              }
            }
          }).catch(() => {
            this.isLoading = false
            this.close()
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
          })
      } else
        this.loading = false
      this.checkin.cod_incricao = ''
      this.checkin.tipo = ''
      this.checkin.eventoId = ''
    },

    async confirmaCheckout() {
      this.checkin.cod_incricao = this.codigo
      this.checkin.tipo = this.acao
      this.checkin.eventoId = this.eventoId
      await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 7:
                //'Checkout confirmado
                this.msgValidacao = res.data.resposta
                this.iconValidacao = 'check_circle_outline'
                this.corValidacao = '#43A047'
                this.validacao = true
                this.loading = false
                break;
              case 6:
                //'O local do evento está vazio'
                this.msgValidacao = res.data.resposta
                this.iconValidacao = 'error_outline'
                this.corValidacao = '#FF8F00'
                this.validacao = true
                this.loading = false
                break;
              default:
                break;
            }
            this.checkin.cod_incricao = ''
            this.checkin.tipo = ''
            this.checkin.eventoId = ''
          }
        })
    },

    async carregaValores() {
      for (var key in this.eventos) {
        if (this.eventos.hasOwnProperty(key)) {
          if (this.eventos[key].id == this.eventoId) {
            this.capacidade = this.eventos[key].vagas
            this.reservados = this.eventos[key].reserva
            this.evento = this.eventos[key].nome
          }

        }
      }

      await axios.post(`${baseApiUrl}Inscricoes/dashboard?access_token=${sessionStorage.getItem('accToken')}`, { "eventoId": this.eventoId })
      .then(res => {
        this.inscritos = res.data.inscritos
        this.inscritosPagos = res.data.confirmados
      })

      try {
        let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"eventoId":"${this.eventoId}"}}&access_token=${sessionStorage.getItem('accToken')}`)
        let inscricoes = res.data
        //this.checkinsRealizados = res.data
        inscricoes.forEach(inscrito => {
          if(inscrito.checkin != null && inscrito.userValidatorCheckinId == this.user.id){
            if(inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizados = this.checkinsRealizados + inscrito.participantes
            else
                this.checkinsRealizados++
          }

          if(inscrito.checkin != null){
            if(inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + inscrito.participantes
            else
                this.checkinsRealizadosTotal++
          }
          
        });      
      } catch (error) {
        //
      }

      await this.calculaPercentuais()

    },

    async cadastroTotal() {
      if(this.user.tipo == 'GERENTE'){
        await axios.post(baseApiUrl + 'Membros/dashboard?access_token=' + sessionStorage.getItem('accToken'), {"igrejaId": this.user.igrejaId})
          .then(response => {
            if (response.data) {
              this.qtdTotal = response.data.total
              this.qtdMembro = response.data.membros
              this.qtdCongregado = response.data.congregados
              this.qtdHomens = response.data.homens
              this.qtdMulheres = response.data.mulheres
              this.qtdMeninos = response.data.meninos
              this.qtdMeninas = response.data.meninas
              this.qtdCelulas = response.data.celulas
              this.qtdRedes = response.data.redes
            }
      })
      this.calculaPercentuais()
      this.pegaQuantidades()
    }
    else if(this.user.tipo == 'BACKUP'){
      await axios.post(baseApiUrl + 'Membros/dashboardBackup?access_token=' + sessionStorage.getItem('accToken'), {"igrejaId": this.user.igrejaId})
          .then(response => {
            if (response.data) {
              this.qtdTotal = response.data.total
              this.qtdMembro = response.data.membros
              this.qtdCongregado = response.data.congregados
              this.qtdHomens = response.data.homens
              this.qtdMulheres = response.data.mulheres
              this.qtdMeninos = response.data.meninos
              this.qtdMeninas = response.data.meninas
              this.qtdCelulas = response.data.celulas
              this.qtdRedes = response.data.redes
            }
      })
      this.calculaPercentuais()
      this.pegaQuantidades()
    }
    else
    if(this.user.tipo == 'LIDER'){
      let celulaLider = await axios.get(baseApiUrl + `Celulas?filter={"where":{"id":"${this.user.celulaId}"}}&access_token=${sessionStorage.getItem('accToken')}`)      
      await axios.post(baseApiUrl + '/Membros/quantidadePorCelula?access_token=' + sessionStorage.getItem('accToken'), {"igrejaId": this.user.igrejaId})
          .then(response => {
            if (response.data) {
              response.data.forEach(celula => {
                if(celula.celula == celulaLider.data[0].nome){
                this.qtdMembro = celula.totalMembros
                this.qtdTotal = celula.totalMembros
                }
              });
            }
      })
      this.calculaPercentuais()
      this.pegaQuantidades()
      this.solicitacoesEnviadas()
      this.aprovacoesPendentes()
    }
    },

    close() {
      this.tipo = 0
      this.dialog = false
      this.corValidacao = '#424f4e'
      setTimeout(() => {
        this.validacao = false
      }, 300);
    },

    closeResultado() {
      if (this.acao == 'CHECKIN') {
        this.tipo = "1"
        this.validacao = false
        this.corValidacao = '#424f4e'
        this.participantes = 0
      } else
        this.close()
    },

    async calculaPercentuais() {
      this.percenteMembros = this.qtdMembro * 100 / this.qtdTotal
      this.percenteCongregados = this.qtdCongregado * 100 / this.qtdTotal
      this.percenteHomens = this.qtdHomens * 100 / this.qtdTotal
      this.percenteMulheres = this.qtdMulheres * 100 / this.qtdTotal
      this.percenteMeninos = this.qtdMeninos * 100 / this.qtdTotal
      this.percenteMeninas = this.qtdMeninas * 100 / this.qtdTotal
      this.isLoading = false
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async doCheckin(item) {
      var vm = this
      this.isLoading = true
      this.checkin.cod_incricao = item.cod_incricao
      this.checkin.tipo = this.acao
      this.checkin.eventoId = item.eventoId
      this.checkin.userValidatorId = this.user.id
      await axios.post(`${baseApiUrl}inscricoes/checkin?access_token=${sessionStorage.getItem('accToken')}`, this.checkin)
      .then(response => {
        if (response.data) {
          this.dialog = true
          this.dialogoInscricoesLocalizadas = false
          switch (response.data.codigo) {
            case 1:
              //'Validação já efetuada anteriormente' 
              if (this.usaQrcode)
                this.audio.play()
              this.participantes = response.data.participantes
              this.detalhes = response.data.detalhes
              this.msgValidacao = response.data.resposta
              this.iconValidacao = 'error_outline'
              this.corValidacao = '#FF8F00'
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
            case 2:
              //'Vagas esgotadas para o evento'
              if (this.usaQrcode)
                this.audio.play()
              this.msgValidacao = response.data.resposta
              this.iconValidacao = 'cancel'
              this.corValidacao = '#D32F2F'
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
            case 3:
              //'Validação efetuada com sucesso'
              if (this.usaQrcode)
                this.audio.play()
              this.participantes = response.data.participantes
              this.detalhes = response.data.detalhes
              this.msgValidacao = response.data.resposta
              this.iconValidacao = 'check_circle_outline'
              this.corValidacao = '#43A047'
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
            case 5:
              //'Inscrição não localizada pra este evento'
              if (this.usaQrcode)
                this.audio.play()
              this.msgValidacao = response.data.resposta
              this.iconValidacao = 'cancel'
              this.corValidacao = '#D32F2F'
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
            case 8:
              //'Inscrição com pagamento pendente'
              if (this.usaQrcode)
                this.audio.play()
              this.msgValidacao = response.data.resposta
              this.iconValidacao = 'error_outline'
              this.corValidacao = '#FF8F00'
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
            default:
              this.validacao = true
              this.loading = false
              this.usaQrcode = false
              break;
          }
          this.isLoading = false
        }
      }).catch(() => {
        this.isLoading = false
        this.close()
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
      })
    },

    async pegaQuantidades() {
      // Limpa os arrays antes de preencher
      this.graficoMembrosCelula.series = [];
      this.graficoMembrosCelula.options.labels = [];
      this.graficoMembrosCelula.options.colors = [];
      this.graficoMembrosRede.series = [];
      this.graficoMembrosRede.options.labels = [];
      this.graficoMembrosRede.options.colors = [];

      let urlCelula = 'Membros/quantidadePorCelula';
      let urlRede = 'Membros/quantidadePorRede';

      if (this.user.tipo === 'BACKUP') {
        urlCelula = 'Membros/quantidadePorCelulaBackup';
        urlRede = 'Membros/quantidadePorRedeBackup';
      }

      // Busca por célula
      let quantidadePorCelula = [];
      await axios.post(baseApiUrl + urlCelula + '?access_token=' + sessionStorage.getItem('accToken'), { "igrejaId": this.user.igrejaId })
        .then(response => {
          if (response.data) {
            quantidadePorCelula = response.data.sort(this.comparacaoCelula);
            for (let i = 0; i < quantidadePorCelula.length; i++) {
              this.graficoMembrosCelula.series.push(quantidadePorCelula[i].totalMembros);
              this.graficoMembrosCelula.options.labels.push(quantidadePorCelula[i].celula + ' - ' + quantidadePorCelula[i].totalMembros);
              this.graficoMembrosCelula.options.colors.push(quantidadePorCelula[i].cor.toUpperCase());
            }
          }
        })
        .catch(() => { /* igreja sem membros (422): gráfico fica vazio */ });

      // Busca por rede
      let quantidadePorRede = [];
      await axios.post(baseApiUrl + urlRede + '?access_token=' + sessionStorage.getItem('accToken'), { "igrejaId": this.user.igrejaId })
        .then(response => {
          if (response.data) {
            quantidadePorRede = response.data.sort(this.comparacaoRede);
            for (let i = 0; i < quantidadePorRede.length; i++) {
              if (quantidadePorRede[i].totalMembros > 0) {
                this.graficoMembrosRede.series.push(quantidadePorRede[i].totalMembros);
                this.graficoMembrosRede.options.labels.push(quantidadePorRede[i].rede + ' - ' + quantidadePorRede[i].totalMembros);
                this.graficoMembrosRede.options.colors.push(quantidadePorRede[i].cor.toUpperCase());
              }
            }
          }
        })
        .catch(() => { /* igreja sem membros (422): gráfico fica vazio */ });
    },
  },
};
</script>

<style>
.dashboard-container {
  padding: 12px;
  background-color: #f5f5f5;
}

.dashboard-title-row {
  margin-top: 8px;
  margin-bottom: 8px;
  padding-top: 0;
  padding-bottom: 0;
}

.dashboard-title {
  font-size: 2rem;
  font-weight: 300;
  color: #424242;
  margin-bottom: 4px;
  margin-top: 0px;
}

@media (max-width: 600px) {
  .dashboard-title-row {
    margin-top: 2px;
    margin-bottom: 2px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .dashboard-title {
    font-size: 1.5rem;
    margin-bottom: 2px;
    margin-top: 0px;
  }
}

.dashboard-card {
  transition: transform 0.2s;
  border-radius: 12px;
  overflow: hidden;
}

.dashboard-card:hover {
  transform: translateY(-5px);
}

.card-title {
  font-size: 1.05rem;
  font-weight: 600;
  padding: 16px;
  color: #16322E;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

/* dashboard claro: números e ícones em teal da marca */
.dashboard-card .display-3,
.dashboard-card .display-2 { color: #00695C; }
.dashboard-card .card-title .v-icon { color: #00695C !important; }
.dashboard-card .subtitle-1 { color: #5b6b67; }

/* cards de estatística coloridos (texto/ícones brancos) */
.stat-card-colored .card-title,
.stat-card-colored .display-3,
.stat-card-colored .display-2,
.stat-card-colored .subtitle-1,
.stat-card-colored .card-title .v-icon { color: #fff !important; }
.stat-card-colored .card-title { border-bottom-color: rgba(255,255,255,.18) !important; }
.dashboard-title { font-family: 'Fraunces', Georgia, serif; font-weight: 600; }

.card-altura-fixa {
  min-height: 170px;
  height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.v-data-table th {
  background-color: #90A4AE;
  font-size: 1rem;
  color: white;
}

.theme--light.v-table thead th {
  color: white;
}

.theme--light.v-datatable thead th.column.sortable:hover {
  color: rgb(17, 16, 16);
}

.container {
  position: relative;
  min-width: 100%;
  overflow: hidden;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
